import React from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";
import ResetPasswordForm from "../../components/auth/ResetPasswordForm";

const ResetPasswordFormPage = () => (
  <React.Fragment>
    <Helmet title="Reset Password" />
    <div className="text-center mt-4">
      <h1 className="h2">Reset password Form</h1>
      {/* <p className="lead">Enter your email to reset your password.</p> */}
    </div>

    <Card>
      <Card.Body>
        <div className="m-sm-4">
          <ResetPasswordForm />
        </div>
      </Card.Body>
    </Card>
  </React.Fragment>
);

export default ResetPasswordFormPage;
